import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { LinkdapiCandidates } from '@/features/linkdapi-candidates'

const searchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  filter: z.string().optional().catch(''),
})

export const Route = createFileRoute('/_authenticated/linkdapi-candidates/')({
  validateSearch: searchSchema,
  component: LinkdapiCandidates,
})
